import { useState } from 'react';

interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <a href="/" className="flex items-center space-x-3">
              <div className="w-10 h-10 flex items-center justify-center bg-gradient-to-br from-amber-500 to-orange-600 rounded-lg">
                <i className="ri-car-line text-2xl text-white"></i>
              </div>
              <span className={`text-xl font-bold font-['Space_Grotesk'] transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                Ace's Auto Body
              </span>
            </a>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('services')} className={`text-sm font-medium transition-colors hover:text-amber-500 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Services
            </button>
            <button onClick={() => scrollToSection('process')} className={`text-sm font-medium transition-colors hover:text-amber-500 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              How It Works
            </button>
            <button onClick={() => scrollToSection('gallery')} className={`text-sm font-medium transition-colors hover:text-amber-500 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className={`text-sm font-medium transition-colors hover:text-amber-500 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Reviews
            </button>
            <button onClick={() => scrollToSection('contact')} className={`text-sm font-medium transition-colors hover:text-amber-500 whitespace-nowrap ${isScrolled ? 'text-gray-700' : 'text-white'}`}>
              Contact
            </button>
            <a href="tel:3105272838" className="px-5 py-2.5 bg-gradient-to-r from-amber-500 to-orange-600 text-white text-sm font-semibold rounded-lg hover:shadow-lg transition-all whitespace-nowrap">
              (310) 527-2838
            </a>
          </div>

          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2"
          >
            <i className={`ri-menu-line text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white shadow-lg">
          <div className="px-4 py-4 space-y-3">
            <button onClick={() => scrollToSection('services')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg whitespace-nowrap">
              Services
            </button>
            <button onClick={() => scrollToSection('process')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg whitespace-nowrap">
              How It Works
            </button>
            <button onClick={() => scrollToSection('gallery')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg whitespace-nowrap">
              Gallery
            </button>
            <button onClick={() => scrollToSection('testimonials')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg whitespace-nowrap">
              Reviews
            </button>
            <button onClick={() => scrollToSection('contact')} className="block w-full text-left px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg whitespace-nowrap">
              Contact
            </button>
            <a href="tel:3105272838" className="block w-full text-center px-5 py-2.5 bg-gradient-to-r from-amber-500 to-orange-600 text-white text-sm font-semibold rounded-lg whitespace-nowrap">
              (310) 527-2838
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
